import Flex from '@Components/Bases/Flex';
import { navbarHeight } from '@Containers/Layout/Navbar';
import { Box } from '@mui/material';
import ReportBreadcrumbs from './Components/ReportBreadcrumbs';
import SidebarContainer from './Containers/SidebarContainer';

import { Outlet } from 'react-router-dom';
import { ProgressBarProvider } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';

const ReportLayout = () => {
  return (
    <ProgressBarProvider>
      <Flex height={`calc(100vh - ${navbarHeight}px)`} overflow="hidden">
        <Box minWidth="289px" overflow="auto">
          <SidebarContainer />
        </Box>
        <Box overflow="auto" width={1}>
          <ReportBreadcrumbs />
          <Outlet />
        </Box>
      </Flex>
    </ProgressBarProvider>
  );
};

export default ReportLayout;
